import React from 'react';
import { Control, UseFormRegister, FieldErrors, useFieldArray } from 'react-hook-form';
import { Branch } from '../../types';
import Input from './Input';
import Select from './Select';
import Button from './Button';

interface BranchContactsSectionProps {
  control: Control<Branch>;
  register: UseFormRegister<Branch>;
  errors: FieldErrors<Branch>;
  employeeOptions: { value: string; label: string }[];
}

const BranchContactsSection: React.FC<BranchContactsSectionProps> = ({
  control,
  register,
  errors,
  employeeOptions,
}) => {
  const { fields, append, remove } = useFieldArray({ control, name: 'contacts' });

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <label className="block text-sm font-medium text-gray-700">Managers & Contacts</label>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          onClick={() => append({ manager: '', phone: '', email: '' })}
        >
          + Add Contact
        </Button>
      </div>

      {fields.map((field, index) => (
        <div key={field.id} className="border border-gray-200 rounded-lg p-4 relative">
          {fields.length > 1 && (
            <button
              type="button"
              onClick={() => remove(index)}
              className="absolute top-2 right-2 text-red-400 hover:text-red-600"
              title="Remove contact"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Select
              label="Manager"
              {...register(`contacts.${index}.manager`)}
              options={employeeOptions}
            />
            <Input
              label="Phone"
              {...register(`contacts.${index}.phone`, {
                pattern: {
                  value: /^[+]?[0-9\s\-()]{4,20}$/,
                  message: 'Invalid phone number'
                }
              })}
              error={errors.contacts?.[index]?.phone?.message}
              placeholder="+1-555-0123"
            />
            <Input
              label="Email"
              type="email"
              {...register(`contacts.${index}.email`, {
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Invalid email address'
                }
              })}
              error={errors.contacts?.[index]?.email?.message}
              placeholder="contact@company.com"
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default BranchContactsSection;
